import { z } from 'zod';
import { CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH } from '../../events/cal-event-template-text-max-length.js';
import { RULE_TYPES } from '../../events/rule-types.js';
import { TEMPLATE_RULE_MAX_AND_CONDITIONS } from '../../events/template-rule-max-and-conditions.js';
const RULE_REFERENCE_MAX_LENGTH = 128;
const RULE_OPERATOR_MAX_LENGTH = 32;
const ruleScalarValueSchema = z.union([
    z
        .string()
        .trim()
        .max(CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH, `Rule value must be ${CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH} characters or fewer.`),
    z.number(),
    z.boolean(),
]);
const ruleValueSchema = z
    .union([
    ruleScalarValueSchema,
    z.array(ruleScalarValueSchema).max(100, 'A rule can list at most 100 values.'),
])
    .optional();
const templateRuleConditionSchema = z.object({
    fieldId: z
        .string()
        .min(1)
        .max(RULE_REFERENCE_MAX_LENGTH, `A rule field must be ${RULE_REFERENCE_MAX_LENGTH} characters or fewer.`),
    operator: z
        .string()
        .min(1)
        .max(RULE_OPERATOR_MAX_LENGTH, `A rule operator must be ${RULE_OPERATOR_MAX_LENGTH} characters or fewer.`),
    value: ruleValueSchema,
});
export const templateRuleInputSchema = z.object({
    type: z.enum(RULE_TYPES),
    targetFieldId: z
        .string()
        .min(1)
        .max(RULE_REFERENCE_MAX_LENGTH, `A rule target must be ${RULE_REFERENCE_MAX_LENGTH} characters or fewer.`),
    condition: templateRuleConditionSchema,
    blockName: z.string().trim().max(60, 'A block name must be 60 characters or fewer.').optional(),
    and: z
        .array(templateRuleConditionSchema)
        .max(TEMPLATE_RULE_MAX_AND_CONDITIONS, `A rule can have at most ${TEMPLATE_RULE_MAX_AND_CONDITIONS} extra conditions.`)
        .optional(),
    value: ruleValueSchema,
});
//# sourceMappingURL=template-rule-input-schema.js.map